import { TicketReportCellAlignmentEnum, TicketReportCellDataTypeEnum } from './../../../../service/dto';
import { Component, Input } from '@angular/core';
import { TicketReportColumnDto, TicketReportColumnTemplateDto, TicketReportColumnValueTypeModeEnum, TicketReportDto, ReportFilterOperatorEnum } from '../../../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
	selector: 'app-ticket-report-form-simple-modal',
	standalone: false,
	templateUrl: './ticket-report-form-simple-modal.component.html',
	styleUrls: ['./ticket-report-form-simple-modal.component.scss']
})
export class TicketReportFormSimpleModalComponent {
	@Input() report!: TicketReportDto;
	@Input() column!: TicketReportColumnDto;
	form!: FormGroup;
	modeOptions: { value: TicketReportColumnValueTypeModeEnum, label: string }[] = [];
	alignmentOptions: { value: TicketReportCellAlignmentEnum, label: string }[] = [
		{value: 'Left', label: 'Left'},
		{value: 'Center', label: 'Center'},
		{value: 'Right', label: 'Right'},
	];
	dataTypeOptions: { value: TicketReportCellDataTypeEnum, label: string }[] = [
		{value: 'Text', label:'Text'},
		{value: 'Number', label:'Number'},
		{value: 'Currency', label:'Currency'}
	];

	constructor(private fb: FormBuilder, private modalRef: NzModalRef, private messageService: NzMessageService) { }

	ngOnInit(): void {
		this.form = this.fb.group({
			title: [this.column.title, [Validators.required]],
			mode: [this.column.mode, [Validators.required]],
			filterOperator: [this.column.filterOperator],
			filterValue: [this.column.filterValue],
			alignment: [this.column.alignment, [Validators.required]],
			dataType: [this.column.dataType, [Validators.required]],
		});

		this.modeOptions = Object.keys(this.column.template!.modes).map(key => {
			const label = this.column.template!.modes[key] as string;
			return { value: key as TicketReportColumnValueTypeModeEnum, label };
		});
	}

	handleDelete(): void {
		const idx = this.report.columns.findIndex(item => item.id === this.column.id);
		if (idx >= 0) this.report.columns.splice(idx, 1);
		this.modalRef.close(true);
	}

	handleSave(): void {
		let out = false;
		const title = this.form.get('title')!.value;
		const mode = this.form.get('mode')!.value;
		const filterOperator = this.form.get('filterOperator')!.value;
		const filterValue = this.form.get('filterValue')!.value;
		const alignment = this.form.get('alignment')!.value;
		const dataType = this.form.get('dataType')!.value;

		if (this.column.title !== title) {
			this.column.title = title;
			out = true;
		}
		if (this.column.mode !== mode) {
			this.column.mode = mode;
			out = true;
		}

		if (this.column.filterValue !== filterValue) {
			this.column.filterValue = filterValue;
			out = true;
		}
		if (this.column.filterOperator !== filterOperator) {
			this.column.filterOperator = filterOperator;
			out = true;
		}
		if (this.column.alignment !== alignment) {
			this.column.alignment = alignment;
			out = true;
		}
		if (this.column.dataType !== dataType) {
			this.column.dataType = dataType;
			out = true;
		}
		this.modalRef.close(out);
	}

	handleCancel(): void {
		this.modalRef.close(false);
	}
}
